module.exports = __webpack_public_path__ + "static/WEDDING E&M-238-e1b7cd74420dc60bbf4052a4bac10e5a.jpg";